export function getEthiopianMonth(gmonth: number): string {
    const ethiopianMonths : { [key: number]: string } = {
        1 : "መስከረም",
        2 : "ጥቅምት",
        3 : "ህዳር",
        4 : "ታህሳስ",
        5 : "ጥር",
        6 : "የካቲት",
        7 : "መጋቢት",
        8 : "ሚያዝያ",
        9 : "ግንቦት",
        10 : "ሰኔ",
        11 : "ሐምሌ",
        12 : "ነሐሴ",
        13 : "ጳጉሜን"
    }

    return ethiopianMonths[gmonth] || "" }


    export function getDay(gmonth: number, lan: string): string {
        const weekday = gmonth === 0 ? 7 : gmonth
        if (lan === "am") {
            const dayNamesAm : { [key: number]: string } = {
                1 : "ሰኞ",
                2 : "ማክሰኞ",
                3 : "ረቡዕ",
                4 : "ሐሙስ",
                5 : "ዓርብ",
                6 : "ቅዳሜ",
                7 : "እሁድ",
            }
    
            return dayNamesAm[weekday] || "" }
    const dayNames : { [key: number]: string } = {
        1 : "Monday",
        2 : "Tuesday",
        3 : "Wednesday",
        4 : "Thursday",
        5 : "Friday",
        6 : "Saturday",
        7 : "Sunday",
    }

    return dayNames[weekday] || "" }

    export function getShortDay(gmonth: number): string {
        const weekday = gmonth === 0 ? 7 : gmonth
        const dayNames : { [key: number]: string } = {
            1 : "Mon",
            2 : "Tue",
            3 : "Wed",
            4 : "Thu",
            5 : "Fri",
            6 : "Sat",
            7 : "Sun",
        }
    
        return dayNames[weekday] || "" }

export function toEthiopianTime(time12h: string, modifier:string): string  {
  // Parse "hh:mm AM/PM"
 
  let [hours, minutes] = time12h.split(":").map(Number);

  // Convert to 24-hour format
  if (modifier === "PM" && hours !== 12) hours += 12;
  if (modifier === "AM" && hours === 12) hours = 0;

  // Convert to Ethiopian time (subtract 6 hours)
  let ethHours = hours - 6;
  if (ethHours < 0) ethHours += 24; // wrap around midnight

  // Determine Ethiopian AM/PM
  const ethModifier = ethHours >= 12 ? "PM" : "AM";

  // Convert back to 12-hour format for Ethiopian time
  ethHours = ethHours % 12 || 12; // handle 0 -> 12

  // Format nicely
  return `${ethHours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;
}

/** Ethiopian time with Amharic suffix: ጠዋት (morning, 2:00–5:00) or ከሰዓት (afternoon, 6:00–1:00) */
export function toEthiopianTimeWithSuffix(time12h: string, modifier: string): string {
  const time = toEthiopianTime(time12h, modifier)
  const [ethHour] = time.split(":").map(Number)
  const isMorning = ethHour >= 2 && ethHour <= 5
  const suffix = isMorning ? "ጠዋት" : "ከሰዓት"
  return `${time} ${suffix}`
}

const ETHIOPIA_UTC_OFFSET_HOURS = 3

/**
 * API returns appointment_time as Gregorian 24h in Ethiopia local but with "Z" (e.g. "2025-06-16T18:00:00.000Z" = 6 PM Ethiopia).
 * This parses such ISO strings and returns a Date for that instant (Ethiopia UTC+3).
 */
export function parseAppointmentTimeAsEthiopiaLocal(iso: string): Date {
  if (typeof iso !== "string") return new Date(iso)
  const match = iso.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?Z$/i)
  if (!match) return new Date(iso)
  const [, y, mo, d, h, mi, sec] = match.map((x, i) => (i > 0 ? parseInt(x, 10) : x))
  // Ethiopia is UTC+3: local 18:00 = UTC 15:00
  return new Date(Date.UTC(y as number, (mo as number) - 1, d as number, (h as number) - ETHIOPIA_UTC_OFFSET_HOURS, mi as number, (sec as number) || 0, 0))
}

const ADDIS_ABABA = "Africa/Addis_Ababa"

/** Format a Date (from parseAppointmentTimeAsEthiopiaLocal) as Gregorian 12-hour in Ethiopia timezone (e.g. "6:00 PM"). */
export function formatTimeGregorianInEthiopia(d: Date): string {
  return d.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: ADDIS_ABABA,
  })
}

/** Format a Date (from parseAppointmentTimeAsEthiopiaLocal) as Ethiopian time with suffix (e.g. "12:00 ከሰዓት"). */
export function formatTimeEthiopianWithSuffix(d: Date): string {
  const str = d.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: ADDIS_ABABA,
  })
  const [time, modifier] = str.split(" ")
  return toEthiopianTimeWithSuffix(time!, modifier!)
}

/** Format a Date in Ethiopia timezone as Gregorian date (e.g. "Monday, Jun 16, 2025"). */
export function formatDateGregorianInEthiopia(d: Date): string {
  return d.toLocaleDateString("en-US", {
    weekday: "long",
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: ADDIS_ABABA,
  })
}

/** Format a Date in Ethiopia timezone as Ethiopian calendar date. */
export function formatDateEthiopian(d: Date): string {
  try {
    return new Intl.DateTimeFormat("am-ET-u-ca-ethiopic", {
      weekday: "long",
      month: "short",
      day: "numeric",
      year: "numeric",
      timeZone: ADDIS_ABABA,
    }).format(d)
  } catch {
    return formatDateGregorianInEthiopia(d)
  }
}
